import script from "./LatestBlogPost.vue?vue&type=script&setup=true&lang=js"
export * from "./LatestBlogPost.vue?vue&type=script&setup=true&lang=js"

import "./LatestBlogPost.vue?vue&type=style&index=0&id=0030f223&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0030f223"]])

export default __exports__